// API plné analýzy v2 (backend: app/api/endpoints/analysis_v2.py)
import { APP_API_BASE } from "./apiConfig";
import { getAuthHeaders } from "./authService";

const BASE = `${APP_API_BASE}/api/analysis`;

async function handle(res) {
  let json = null;
  try {
    json = await res.json();
  } catch (e) {
    json = null;
  }
  if (!res.ok) {
    const detail = json?.detail;
    const msg = typeof detail === "string" ? detail : `Chyba serveru (${res.status})`;
    const err = new Error(res.status === 402 ? "Nemáte dostatek kreditů." : msg);
    err.status = res.status;
    throw err;
  }
  return json;
}

export async function createAnalysisJob({ files, ico, nace }) {
  const form = new FormData();
  files.forEach((f) => form.append("files", f));
  if (ico) form.append("ico", ico);
  if (nace) form.append("nace", nace);
  const res = await fetch(`${BASE}/jobs`, { method: "POST", headers: { ...getAuthHeaders() }, body: form });
  return handle(res);
}

export async function getAnalysisJob(id) {
  const res = await fetch(`${BASE}/jobs/${id}`, { headers: { ...getAuthHeaders() } });
  return handle(res);
}

export async function listAnalysisJobs() {
  const res = await fetch(`${BASE}/jobs`, { headers: { ...getAuthHeaders() } });
  return handle(res);
}

export async function correctAnalysisLines(id, lines) {
  const res = await fetch(`${BASE}/jobs/${id}/lines`, {
    method: "PATCH",
    headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify({ lines }),
  });
  return handle(res);
}

// jiný obor pro srovnání u hotové analýzy (nace = null -> obor z registru)
export async function changeAnalysisIndustry(id, nace) {
  const res = await fetch(`${BASE}/jobs/${id}/industry`, {
    method: "PATCH",
    headers: { ...getAuthHeaders(), "Content-Type": "application/json" },
    body: JSON.stringify({ nace: nace || null }),
  });
  return handle(res);
}

export async function listIndustries() {
  const res = await fetch(`${BASE}/industries`, { headers: { ...getAuthHeaders() } });
  return handle(res);
}
